var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40926 5.1045C6.76251 6.16997 6.35194 6.56013 6.35194 6.56013L5.14287 7.59986C4.65835 7.99444 5.03624 8.63463 5.03624 8.63463C7.72653 13.0159 10.2023 14.1122 11.1184 14.6231C11.7813 14.9928 12.1057 14.6232 12.1057 14.6232L13.6146 12.9205C14.1383 12.2242 14.6564 12.586 14.6564 12.586L18.3692 14.745C18.9972 15.0847 18.8528 15.9632 18.5372 16.7464C18.225 17.5206 16.752 19.4635 14.5847 19.3505C12.4168 19.238 8.44967 18.1799 5.34719 14.5268C2.21406 10.838 0.839405 7.42569 0.839405 7.42569C-0.74905 3.90021 1.81045 1.56882 1.81045 1.56882C3.83658 -0.178245 5.08135 1.22845 5.08135 1.22845C5.08135 1.22845 6.05668 4.03834 6.40926 5.1045Z",
    fill: "#229CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.8481c2f8831cd9de67706d1c1d2e2f74.svg";
export { ForwardRef as ReactComponent };